import { React, Redirect } from "ui-kit";

import { generators } from "../paths";

export const Home = () => {
  return <Redirect to={generators.groups.list()} />;
};
